// src/components/DynamicReportInputs/PeriodSelector.js
import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import DateField from "./PeriodField";

const useStyles = makeStyles((theme) => ({
  textField: {
    minWidth: 250,
    width: "100%",
  },
}));

export default function PeriodSelector({
  value,
  onChange,
  label = "Período",
  error = null,
  required = false,
  disabled = false,
  minDate,
}) {
  const classes = useStyles();

  // string "YYYYMM" -> DateField
  const selectedDate = useMemo(() => {
    if (value && String(value).length === 6) {
      const year = parseInt(String(value).substring(0, 4), 10);
      const month = parseInt(String(value).substring(4, 6), 10) - 1;
      return new Date(year, month, 1);
    }
    return null;
  }, [value]);

  // DateField -> string "YYYYMM"
  const handleDateChange = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      onChange(`${year}${month}`);
    } else {
      onChange("");
    }
  };

  return (
    <DateField
      label={label}
      value={selectedDate}
      onChange={handleDateChange}
      views={["year", "month"]}
      format="MM/yyyy"
      fieldClassName={classes.textField}
      error={!!error}
      helperText={error}
      required={required}
      disabled={disabled}
      minDate={minDate}
      clearable={true}
      placeholder={label}
    />
  );
}
